import './Theme.SimpleFileInput.scss';
export default `themeSimpleFileInput`;
